export default __webpack_public_path__ + "static/media/3122.e3cf72e8.jpg";